import { useState, useEffect } from 'react';

import { TopBar, Hero, ProblemSection } from './sections/hero.jsx';
import { TrialsSection, VerdictSimulator } from './sections/trials.jsx';
import {
  PricingSection,
  SquadSection,
  ClubSection,
  FAQ,
  Apply,
  Footer,
} from './sections/rest.jsx';
import { AlternativesCompare } from './sections/expansions.jsx';

/** One-time design tokens on <html> (formerly dev tweaks). */
function applyDesignTokens() {
  const d = document.documentElement.dataset;
  d.density = 'tight';
  d.illustration = 'ascii';
  d.display = 'instrument';
  d.logo = 'grotesk';
  d.squad = 'glyph';
}

const THEME_STORAGE_KEY = '02100:theme';
function readInitialTheme() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch (e) {}
  if (
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: light)').matches
  ) {
    return 'light';
  }
  return 'dark';
}

export default function App() {
  const [theme, setTheme] = useState(readInitialTheme);

  useEffect(() => {
    applyDesignTokens();
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch (e) {}
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && (e.key === 'L' || e.key === 'l')) {
        e.preventDefault();
        toggleTheme();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <TopBar theme={theme} onToggleTheme={toggleTheme} />
      <main className="shell" style={{ paddingTop: 48 }}>
        <Hero />
        <ProblemSection />
        <TrialsSection />
        <VerdictSimulator />
        <SquadSection />
        <PricingSection />
        <AlternativesCompare />
        <ClubSection />
        <FAQ />
        <Apply />
      </main>
      <Footer />
    </>
  );
}
